import { render, staticRenderFns } from "./EditUserProfileComplete.vue?vue&type=template&id=894c6aa0&"
import script from "./EditUserProfileComplete.vue?vue&type=script&lang=js&"
export * from "./EditUserProfileComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports